@if (showSearchBar.includes(type) && showFilter) {
    <div class="panel panel--toolbar">
        <label class="form-label" for="listado-busqueda">Buscar</label>
        <div class="search-field">
            <i class="bi bi-search" aria-hidden="true"></i>
            @if (type === ItemType.ASOCIACIONES) {
                <input id="listado-busqueda" type="search" class="form-control" [formControl]="searchControl" autocomplete="off" placeholder="Nombre, número o lema de la asociación" (input)="filterItems($event)">
            }
            @if (type === ItemType.ASOCIADOS) {
                <input id="listado-busqueda" type="search" class="form-control" [formControl]="searchControl" autocomplete="off" placeholder="Nombre, apellido o DNI/NIE/SIP" (input)="filterItems($event)">
            }
        </div>
    </div>
}
<div class="listado-host">
    @if (loading) {
        <app-spinner [fullscreen]="false"></app-spinner>
    }
    @if (!loading) {
        @if (!itemsToShow || itemsToShow.length === 0) {
            <app-estado-panel icono="bi-search" titulo="Sin resultados" [texto]="searchControl.value ? 'No hay elementos que coincidan con la búsqueda.' : 'No hay elementos para mostrar.'"></app-estado-panel>
        } @else {
            <p class="visually-hidden" aria-live="polite">{{ itemsToShow.length }} resultado(s)</p>
            <div class="cards-grid">
                @for (item of itemsToShow | paginate: {itemsPerPage: itemsPerPage, currentPage: p }; track $index) {
                    <app-item
                        [type]="type === ItemType.CARGOASOCIADOASOCIACION ? ItemType.ASOCIADOS : type"
                        [item]="item"
                        (openItem)="this.openItem.emit(item)"
                        (deleteItem)="this.deleteItem.emit(item)"
                    ></app-item>
                }
            </div>
        }
        <div class="pager" [ngClass]="marginPagination ? 'my-3' : 'my-2'">
            <pagination-controls
                (pageChange)="cambiarPagina($event)"
                [autoHide]="true"
                [responsive]="true"
                previousLabel="Anterior"
                nextLabel="Siguiente"
                screenReaderPaginationLabel="Paginación"
                screenReaderPageLabel="página"
                screenReaderCurrentLabel="Estás en la página"
            ></pagination-controls>
        </div>
    }
</div>
